import { useDataProvider } from "@exonn/base";
import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { useResourceQueries } from "@exonn/base";
import { useContentLocale } from "src/auth/hooks/useContentLocale.tsx";

export type ValidUseOneData<Resource = any> = {
  data: Resource;
  available_languages?: string[];
};

export type UseOneQueryOptions<
  Resource = any,
  Data = ValidUseOneData<Resource>,
> = Omit<UseQueryOptions<Data, any, Data>, "queryFn" | "queryKey">;

export const useOne = <
  Resource = any,
  Data = ValidUseOneData<Resource>,
>(props: {
  resource: string;
  id: string;
  lang?: string;
  meta?: any;
  requestParams?: Record<string, any>;
  includes?: string[];
  queryOptions?: UseOneQueryOptions<Resource, Data>;
}) => {
  const {
    resource,
    id,
    lang,
    queryOptions,
    requestParams,
    includes,
    meta: metaProp,
  } = props;
  const dataProvider = useDataProvider();

  const queries = useResourceQueries();

  const defaultLang = useContentLocale();
  const locale = lang || defaultLang;

  const meta = {
    requestParams,
    locale: locale,
    include: includes,
    ...metaProp,
  };

  const detailParams = {
    id,
    resource,
    meta,
  };
  return useQuery({
    queryKey: queries.detail(detailParams),
    queryFn: ({ signal }) => {
      return dataProvider.getOne({
        ...detailParams,
        signal,
      });
    },
    ...queryOptions,
  });
};
